export const emptyFunc = () => { };